import React, { useState, useEffect } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { Header } from "../Components";
import axios from "axios";
import {
  FaSearch,
  FaTrash,
  FaTimes,
  FaFileExcel,
  FaFilePdf,
  FaPlus,
  FaEdit,
} from "react-icons/fa";
import { useBaseUrl } from "../Contexts/BaseUrlContext";
import { useStateContext } from "../Contexts/ContextProvider";
// Grid column configuration
const facultyGrid = [
  {
    field: "id",
    headerText: "ID",
    width: 80,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">ID</span>,
  },
  {
    field: "name",
    headerText: "Name",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Name</span>,
  },
  {
    field: "designation",
    headerText: "Designation",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Designation</span>,
  },
  {
    field: "department",
    headerText: "Department",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Department</span>,
  },
  {
    field: "image_url",
    headerText: "Image",
    width: 100,
    textAlign: "Center",
    template: (props) => (
      <img
        src={props.image_url}
        alt="Faculty"
        className="w-12 h-12 object-cover rounded"
      />
    ),
    headerTemplate: () => <span className="font-bold">Image</span>,
  },
  {
    field: "Actions",
    headerText: "Actions",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Actions</span>,
    template: (props) => (
      <div className="flex justify-center gap-3">
        <button
          className="text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.editHandler(props)}
          title="Edit"
        >
          <FaEdit size={18} />
        </button>
        <button
          className="text-red-600 hover:text-red-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.deleteHandler(props.id)}
          title="Delete"
        >
          <FaTrash size={18} />
        </button>
      </div>
    ),
  },
];

const Faculty = () => {
  const [facultyData, setFacultyData] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    department: "",
    image: null,
    message: "",
    index_no: "",
  });

  const { baseUrl } = useBaseUrl();

  // Fetch faculty data from API
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("action", "get");

      const response = await axios.post(`${baseUrl}faculty.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("API Response:", response.data);
      if (response.data.status) {
        setFacultyData(response.data.data || []);
      } else {
        setErrorMessage(response.data.error || "Failed to fetch faculty.");
      }
    } catch (error) {
      console.error("Axios Error:", error.response || error);
      setErrorMessage(
        "Error connecting to the server. Please check your network or API configuration."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle add faculty
  const handleAddFaculty = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const Formdata = new FormData();
      Formdata.append("action", "add");
      Formdata.append("name", formData.name);
      Formdata.append("designation", formData.designation);
      Formdata.append("department", formData.department);
      Formdata.append("message", formData.message);
       Formdata.append("image", formData.image);
       Formdata.append("index_no", formData.index_no);

      const response = await axios.post(`${baseUrl}faculty.php`, Formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("Add Response:", response.data);
      if (response.data.status) {
        fetchData();
        // setFacultyData([...facultyData, response.data.data]);
        setIsAddModalOpen(false);
        setFormData({ name: "", designation: "", department: "", image: null, index_no: "" });
        alert("Faculty added successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to add faculty.");
      }
    } catch (error) {
      console.error("Error adding faculty:", error.response || error);
      setErrorMessage("Failed to add faculty.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit faculty
  const handleEditFaculty = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const data = new FormData();
      data.append("action", "update");
      data.append("id", selectedFaculty.id);
      data.append("name", formData.name);
      data.append("designation", formData.designation);
      data.append("department", formData.department);
       data.append("message", formData.message);
       data.append("index_no", formData.index_no);
       if (formData.image) data.append("image", formData.image);

      const response = await axios.post(`${baseUrl}faculty.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("Edit Response:", response.data);
      if (response.data.status) {
        fetchData();
        // setFacultyData(facultyData.map(item => item.id === selectedFaculty.id ? response.data.data : item));
        setIsEditModalOpen(false);
        setFormData({
          name: "",
          designation: "",
          department: "",
          image: null,
          message: "",
          index_no: "",
        });
        setSelectedFaculty(null);
        alert("Faculty updated successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to update faculty.");
      }
    } catch (error) {
      console.error("Error updating faculty:", error.response || error);
      setErrorMessage("Failed to update faculty.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete action
  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this faculty?")) {
      try {
        const data = new FormData();
        data.append("action", "delete");
        data.append("id", id);

        const response = await axios.post(`${baseUrl}faculty.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            // 'Accept': 'application/json',
          },
          withCredentials: true,
        });
        console.log("Delete Response:", response.data);
        if (response.data.status) {
          setFacultyData(facultyData.filter((item) => item.id !== id));
          alert("Faculty deleted successfully.");
        } else {
          alert(
            "Failed to delete faculty: " +
              (response.data.error || "Unknown error")
          );
        }
      } catch (error) {
        console.error("Error deleting faculty:", error.response || error);
        alert("Failed to delete faculty.");
      }
    }
  };

  // Handle edit action
  const editHandler = (faculty) => {
    setSelectedFaculty(faculty);
    setFormData({
      name: faculty.name,
      designation: faculty.designation,
      department: faculty.department,
      image: null,
      message: faculty.message || "",
      index_no: faculty.index_no || "",
    });
    setIsEditModalOpen(true);
  };

  // Search filter
  const filteredData = facultyData.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.designation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.department?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Inject handlers into grid data
  const gridData = filteredData.map((item) => ({
    ...item,
    editHandler,
    deleteHandler,
  }));

  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div
      style={currentMode === "Dark" ? { backgroundColor: "#20232A" } : {}}
      className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 animate-fadeIn bg-gray-100 min-h-screen"
    >
      <Header category="Dashboard" title="Faculty Management" />

      {/* Error Message */}
      {errorMessage && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
          {errorMessage}
        </div>
      )}

      {/* Search and Controls */}
      <div className="mb-6 flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, designation, or department..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 bg-white shadow-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex gap-2">
          <button
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300 shadow-md"
            onClick={() => {
              setFormData({
                name: "",
                designation: "",
                department: "",
                image: null,
                index_no: "",
              });
              setIsAddModalOpen(true);
            }}
          >
            <FaPlus className="mr-2" /> Add Faculty
          </button>
          <button
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("facultyGrid")
                .ej2_instances[0].excelExport()
            }
            disabled={isLoading}
          >
            <FaFileExcel className="mr-2" /> Export Excel
          </button>
          <button
            className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("facultyGrid")
                .ej2_instances[0].pdfExport()
            }
            disabled={isLoading}
          >
            <FaFilePdf className="mr-2" /> Export PDF
          </button>
        </div>
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
        </div>
      )}

      {/* Grid */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <GridComponent
          id="facultyGrid"
          dataSource={gridData}
          allowPaging={true}
          allowSorting={true}
          allowExcelExport={true}
          allowPdfExport={true}
          allowFiltering={true}
          allowResizing={true}
          pageSettings={{ pageSize: 10, pageSizes: [10, 20, 50] }}
          filterSettings={{ type: "Menu", showFilterBarStatus: true }}
        >
          <ColumnsDirective>
            {facultyGrid.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject
            services={[
              Resize,
              Sort,
              ContextMenu,
              Filter,
              Page,
              ExcelExport,
              PdfExport,
            ]}
          />
        </GridComponent>
      </div>

      {/* Add Faculty Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Add Faculty</h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsAddModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleAddFaculty} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Designation
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  required
                >
                <option value="">Select Designation</option>
                <option value="President">President</option>
                <option value="Vice President">Vice President</option>
                <option value="Secretary">Secretary</option>
                <option value="Principal">Principal</option>
                <option value="Vice Principal">Vice Principal</option>
                <option value="Professor">Professor</option>
                <option value="Associate Professor">Associate Professor</option>
                <option value="Assistant Professor">Assistant Professor</option>
                <option value="Lecturer">Lecturer</option>
                <option value="Admin Officer">Admin Officer</option>
                <option value="Office Superintendent">Office Superintendent</option>
                <option value="Sr. Clerk">Sr. Clerk</option>
                <option value="Jr. Clerk">Jr. Clerk</option>
                <option value="Accountant">Accountant</option>
                <option value="Peon">Peon</option>
                <option value="Driver">Driver</option>
                <option value="Security">Security</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Department
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.department}
                  onChange={(e) =>
                    setFormData({ ...formData, department: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Index
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                   value={formData.index_no}
                   onChange={(e) =>
                     setFormData({ ...formData, index_no: e.target.value })
                   }
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                ></textarea>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.files[0] })
                  }
                  required
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Add Faculty
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Faculty Modal */}
      {isEditModalOpen && selectedFaculty && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Edit Faculty</h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsEditModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleEditFaculty} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Designation
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  required
                >
                    <option value="">Select Designation</option>
                    <option value="President">President</option>
                    <option value="Vice President">Vice President</option>
                    <option value="Secretary">Secretary</option>
                    <option value="Principal">Principal</option>
                    <option value="Vice Principal">Vice Principal</option>
                    <option value="Professor">Professor</option>
                    <option value="Associate Professor">Associate Professor</option>
                    <option value="Assistant Professor">Assistant Professor</option>
                    <option value="Lecturer">Lecturer</option>
                    <option value="Admin Officer">Admin Officer</option>
                    <option value="Office Superintendent">Office Superintendent</option>
                    <option value="Sr. Clerk">Sr. Clerk</option>
                    <option value="Jr. Clerk">Jr. Clerk</option>
                    <option value="Accountant">Accountant</option>
                    <option value="Peon">Peon</option>
                    <option value="Driver">Driver</option>
                    <option value="Security">Security</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Department
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.department}
                  onChange={(e) =>
                    setFormData({ ...formData, department: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Index
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                   value={formData.index_no}
                   onChange={(e) =>
                     setFormData({ ...formData, index_no: e.target.value })
                   }
                />
              </div>
              {formData.message.length ? (
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Message
                  </label>
                  <textarea
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                  ></textarea>
                </div>
              ) : null}

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Image (optional)
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={(e) =>
                    setFormData({ ...formData, image: e.target.files[0] })
                  }
                />
                {selectedFaculty.image_url && (
                  <img
                    src={selectedFaculty.image_url}
                    alt="Current"
                    className="mt-2 w-24 h-24 object-cover rounded"
                  />
                )}
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Update Faculty
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Faculty;
